export default __webpack_public_path__ + "static/media/Smart_wall_switch.80386d50.svg";